import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LocalStorage } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private readonly http = inject(HttpClient);
  private readonly localStorageService = inject(LocalStorage);
  private readonly router = inject(Router);

  /**
   * Posts request nonce
   * @param walletAddress
   * @returns
   */
  postRequestNonce(walletAddress: any) {
    return this.http.post(`${environment.API_BASE_URL}auth/nonce`, { "walletAddress": walletAddress })
  }

  /**
   * Posts authenticate
   * @param data
   * @returns
   */
  postAuthenticate(data: any) {
    return this.http.post(`${environment.API_BASE_URL}auth/admin/login`, data)
  }

  /**
   * Logs in a sub-admin
   * @param data Login data for the sub-admin
   * @returns An observable containing the response from the server
   */
  subAdminLogin(data: any) {
    return this.http.post(`${environment.API_BASE_URL}auth/sub-admin/login`, data)
  }

  /**
   * Updates the admin display name.
   */
  updateAdminName(name: string) {
    return this.http.patch(`${environment.API_BASE_URL}admin/name`, { name });
  }

  /**
   * Updates the sub-admin display name.
   */
  updateSubAdminName(name: string) {
    return this.http.patch(`${environment.API_BASE_URL}sub-admin/name`, { name });
  }

  /**
   * Logs out the user and clears their login response and access token from local storage.
   * Navigates the user back to the login page.
   */
  logout() {
    this.localStorageService.clearLocalStorage('accessToken');
    this.localStorageService.clearLocalStorage('loginResponse');
    this.localStorageService.clearLocalStorage('subAdminDetails');
    this.localStorageService.clearLocalStorage('adminProfileName');
    this.localStorageService.clearLocalStorage('subAdminProfileName');
    this.router.navigate(['']);    
  }

}
